import React, { useEffect } from "react";

const JdoodleEmbed = ({ url }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.jdoodle.com/assets/jdoodle-pym.min.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <iframe
      src={url}
      width="100%"
      height="600"
      frameBorder="0"
      title="JDoodle Code Editor"
      style={{ borderRadius: "6px" }}
    ></iframe>
  );
};

export default JdoodleEmbed;
